import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';
import { NAME_SPACE } from 'i18n';
import { Button } from 'shared/Buttons';
import { useHorizontalStepperStyles } from './horizontalStepper.styles';

export default function HorizontalStepper({ steps = [], stepsContent = [], onPressNext, onPressBack, disableActions }) {
  const { t } = useTranslation(NAME_SPACE.COMMON);
  const classes = useHorizontalStepperStyles();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = nextStep => {
    onPressNext && onPressNext(nextStep);
    setActiveStep(nextStep);
  };

  const handleBack = nextStep => {
    onPressBack && onPressBack(nextStep);
    setActiveStep(nextStep);
  };

  const getStepContent = useCallback(
    activeStep => {
      return stepsContent[activeStep];
    },
    [stepsContent]
  );

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        <div className={classes.dialogContent}>{getStepContent(activeStep)}</div>
        <div className={classes.actions}>
          <Button
            text={activeStep === 0 ? t('actions.cancel') : t('actions.back')}
            icon={<NavigateBeforeIcon />}
            className={classes.buttonBack}
            onClick={() => handleBack(activeStep - 1)}
            disabled={disableActions}
          />
          <Button
            disabled={activeStep >= steps.length - 1 || disableActions}
            text={activeStep === steps.length - 1 ? t('actions.finish') : t('actions.next')}
            icon={<NavigateNextIcon />}
            className={classes.buttonNext}
            onClick={() => handleNext(activeStep + 1)}
          />
        </div>
      </div>
    </div>
  );
}

HorizontalStepper.propTypes = {
  steps: PropTypes.array,
  stepsContent: PropTypes.array,
  onPressNext: PropTypes.func.isRequired,
  onPressBack: PropTypes.func.isRequired,
  disableActions: PropTypes.bool
};
